import glamorous from 'glamorous'

import * as colours from '../../../../../styles/colours'

export const StyledLabel = glamorous.label({
  paddingBottom: 6,
  color: colours.basicBlMain,
  fontSize: 13,
  lineHeight: 18 / 13,
})



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Input/components/Label/Label.glamorous.tsx